import { ActionTree, ActionContext } from 'vuex';
import { QuoteApi } from '@/api/quote-api';
import { QuoteFilters } from '@/models/quote-filters';
import { Mutations } from '@/stores/quotes/mutation-constants';
import { State } from '@/stores/quotes/state';
import { Forbidden } from '@/models/forbidden-error';
import router from '@/router';
import { NotFound } from '@/models/not-found-error';

const api = new QuoteApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>, filters: QuoteFilters) => {
        try {
            const result = await api.fetchAsync(filters);
            context.commit(Mutations.SetAllQuotes, result.quotes);
            // context.commit(Mutations.SetCurrentPageSize, result.pageSize);
            context.commit(Mutations.SetAllQuotesTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
            context.commit(Mutations.SetAllQuotesTotalQuotes, result.total);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
    public updateAllQuotesFilterStatus = (context: ActionContext<State, any>, value: number | string | null) => {
        context.commit(Mutations.SetAllQuotesFilterStatus, value);
    }
    public updateAllQuotesPage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetAllQuotesPage, value);
    }
    public updateAllQuotesFrom = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllQuotesFrom, value);
    }
    public updateAllQuotesTo = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetAllQuotesTo, value);
    }
}
